// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"5f91b440195220f959d9","993":"74094b29bff150792c0e"}[chunkId] + ".js");